export default __webpack_public_path__ + "static/media/milk.fd6b111e.png";